import script from "./EmailSentTable.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailSentTable.vue?vue&type=script&setup=true&lang=js"

import "./EmailSentTable.vue?vue&type=style&index=0&id=aae8eb82&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aae8eb82"]])

export default __exports__